import { render, staticRenderFns } from "./CreateUpdateClientNotePopup.vue?vue&type=template&id=3eba1b6e"
import script from "./CreateUpdateClientNotePopup.vue?vue&type=script&lang=js"
export * from "./CreateUpdateClientNotePopup.vue?vue&type=script&lang=js"
import style0 from "./CreateUpdateClientNotePopup.vue?vue&type=style&index=0&id=3eba1b6e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports